"use client";

import React from "react";
import { CircleCheck, Loader, Send } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
function DigitalisationForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-12 text-center space-y-4 animate-in fade-in zoom-in duration-500">
        <div className="size-16 bg-primary/20 rounded-lg flex items-center justify-center mb-4">
          <CircleCheck className="size-8 text-primary" />
        </div>
        <h3 className="text-2xl font-default font-semibold text-foreground">
          Message Received
        </h3>
        <p className="text-muted-foreground max-w-md mx-auto">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="mt-6 border-primary/50 text-primary hover:bg-primary/10 hover:text-primary">
          Send Another Message
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="name" rules={{
        required: "Full name is required",
        minLength: {
          value: 2,
          message: "Minimum 2 characters"
        },
        maxLength: {
          value: 100,
          message: "Maximum 100 characters"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-default uppercase tracking-wider text-xs">Full Name</FormLabel>
              <FormControl>
                <Input placeholder="John Doe" className="bg-background/50 border-border text-foreground placeholder:text-muted-foreground/40 focus-visible:ring-primary focus-visible:border-primary rounded-md" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Email address is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-default uppercase tracking-wider text-xs">Email Address</FormLabel>
              <FormControl>
                <Input type="email" placeholder="john@yedeyinvestments.com" className="bg-background/50 border-border text-foreground placeholder:text-muted-foreground/40 focus-visible:ring-primary focus-visible:border-primary rounded-md" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="company" rules={{
        required: "Portfolio size or interest is required",
        minLength: {
          value: 2,
          message: "Minimum 2 characters"
        },
        maxLength: {
          value: 150,
          message: "Maximum 150 characters"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-default uppercase tracking-wider text-xs">Investment Focus</FormLabel>
              <FormControl>
                <Input placeholder="Crypto, Equities, or Both" className="bg-background/50 border-border text-foreground placeholder:text-muted-foreground/40 focus-visible:ring-primary focus-visible:border-primary rounded-md" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" rules={{
        pattern: {
          value: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/,
          message: "Invalid phone format"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-default uppercase tracking-wider text-xs">X Handle (Optional)</FormLabel>
              <FormControl>
                <Input type="text" placeholder="@yourhandle" className="bg-background/50 border-border text-foreground placeholder:text-muted-foreground/40 focus-visible:ring-primary focus-visible:border-primary rounded-md" {...field} />
              </FormControl>
              <FormDescription className="text-muted-foreground/60 text-xs">
                Follow @yedeyEsp for real-time market updates.
              </FormDescription>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="message" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-foreground font-default uppercase tracking-wider text-xs">Inquiry Details</FormLabel>
            <FormControl>
              <textarea placeholder="Tell us about your investment goals or specific questions..." className="flex min-h-[120px] w-full rounded-md border bg-background/50 border-border px-3 py-2 text-sm text-foreground shadow-md placeholder:text-muted-foreground/40 focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-primary/30 focus-visible:border-primary disabled:cursor-not-allowed disabled:opacity-50 resize-y font-sans" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-md">
          <p className="text-destructive text-sm font-medium">{submitError}</p>
        </div>}

      <div className="pt-4 flex justify-center">
        <Button type="submit" size="lg" disabled={isSubmitting} className="w-full md:w-auto min-w-[240px] bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/20 font-default font-bold uppercase tracking-widest rounded-md">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-5" />
              Processing...
            </> : <>
              Secure Your Edge
              <Send className="ml-2 size-4" />
            </>}
        </Button>
      </div>
    </Form>;
}
export default function PretADigitaliserVotreLogistique() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}